import React, { Component } from 'react'


import T from '../../translate/T'
import FontIcon from '../../atoms/FontIcon'
import Button from '../../atoms/Button'

import css from './style.css'

export default class ImageDropArea extends Component {
    componentDidMount() {
        let dropzone = this.refs.droparea

        dropzone.ondrop = (e) => {
            e.preventDefault()
            e.stopPropagation()
            dropzone.className = `${css.droparea} ${this.props.theme ? css[this.props.theme] : null}`

            this.change({
                target: {
                    files: e.dataTransfer.files
                }
            })
        }
       
  
        dropzone.ondragover = (e) => {
            e.stopPropagation()
            dropzone.className = `${css.droparea} ${this.props.theme ? css[this.props.theme] : null} ${css.dragover}`
            return false
        }
  
        dropzone.ondragleave = (e) => {
            dropzone.className = `${css.droparea} ${this.props.theme ? css[this.props.theme] : null}`
            return false;
        }
    }

    change(e) {
        let el = e.target
        var files = el.files
        for (var i = 0; i < files.length; i++) {
            var file = files[i]
            if(file.type.split('/')[0] !== 'image') {
                delete el.files[i]
            }

        }
        this.props.files(el.files)
        el.value = ''
    }

    render() {
        return (
            <div className={[css.droparea, css[this.props.theme]].join(' ')} style={{...this.props.style}} ref='droparea'>
                <input className={css.fileUpload} type='file' ref='files' onChange={(e) => this.change(e)} multiple accept="image/*"/>
                <div className={css.icon}>
                    <FontIcon name='camera' color={this.props.theme === "primary" ? '#fff' : '#f50'}/>
                </div>
                <div className={css.msgDefault}>
                    {T.txt('c_drag_your_images')}
                </div>
                <div className={css.msgDrop}>
                    {T.txt('c_drop_your_images')}
                </div>
                <div className={css.btn}>
                    <Button type='button' theme={this.props.theme === "primary" ? 'secondary-light' : 'secondary'} inline onClick={() => { this.refs.files.click() }}>{T.text('c_find_in_computer')}</Button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/ImageDropArea-v1/index.js